import { ModuleLanding } from '../ModuleLanding';

export default function RCP(): JSX.Element {
  return (
    <ModuleLanding
      code="RCP"
      configDiagnostics={[
        { label: 'Owner app', value: 'apps/RCP-portal (Wave 3)' },
        { label: 'Stack', value: 'Static Web App + /portal/* routes' },
        { label: 'Auth', value: 'B2C Email OTP (Banno SSO later)' },
      ]}
    />
  );
}
